export const navLinks = [
  { label: 'Home', path: '/', icon: 'Home' },
  { label: 'Prices', path: '/Prices', icon: 'DollarSign' },
  { label: 'TOS', path: '/TOS', icon: 'Shield' },
  { label: 'Gallery', path: '/Gallery', icon: 'Image' },
  { label: 'Queue', path: '/Queue', icon: 'CalendarCheck' },
  { label: 'Feedback', path: '/Feedback', icon: 'MessageSquare' },
  { label: 'Admin', path: '/Admin', icon: 'Lock' },
];

export const heroData = {
  title: 'SNIDER',
  subtitle: 'VRChat & VTuber Retexture Artist',
  description: 'Transforming avatars with custom textures. Watch me work live on Twitch!',
  commissionsOpen: true,
  backgroundImage: 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/698bfab8118f14d14ebf9c87/39ccc2eec_New_Ref_8-30-2021.jpg',
  twitchUrl: 'https://www.twitch.tv/sniderwolf',
};

export const pricingData = [
  {
    id: 1,
    title: 'VRChat PC Retexture',
    description: 'Custom retexture for PC VRChat avatars',
    price: 30,
    features: ['High-quality texture work', 'Unlimited revisions during process', 'Fast turnaround'],
    highlighted: false,
  },
  {
    id: 2,
    title: 'VRChat Quest Retexture',
    description: 'Optimized retexture for Quest avatars',
    price: 30,
    features: ['Quest-optimized textures', 'Performance friendly', 'Color-matched to original'],
    highlighted: false,
  },
  {
    id: 3,
    title: 'PC + Quest Bundle',
    description: 'Complete package for both platforms',
    price: 45,
    features: ['Both PC & Quest versions', 'Consistent look across platforms', 'Best value option'],
    highlighted: true,
    badge: 'BEST VALUE',
  },
  {
    id: 4,
    title: 'VRM/VTuber Avatar',
    description: 'Custom retexture for VTuber models',
    price: 35,
    features: ['VRM format support', 'Stream-ready output', 'Multiple expression compatibility'],
    highlighted: false,
  },
];

export const addOns = [
  { text: 'Unity upload work available for +$10-15 more', color: 'cyan' },
  { text: 'NSFW work available for +$5-10 more', color: 'amber' },
];

export const commissionTypes = [
  { value: 'VRChat PC', label: 'VRChat PC Retexture - $30' },
  { value: 'VRChat Quest', label: 'VRChat Quest Retexture - $30' },
  { value: 'PC + Quest Bundle', label: 'PC + Quest Bundle - $45' },
  { value: 'VRM/VTuber', label: 'VRM/VTuber Avatar - $35' },
];

export const feedbackTypes = [
  { value: 'General Website Feedback', label: 'General Website Feedback' },
  { value: 'Commission Experience', label: 'Commission Experience' },
];

export const discountTiers = [
  {
    id: 1,
    title: 'Tier 1 Subscriber',
    description: 'Subscribe on Twitch',
    benefit: '25% off commissions',
    color: 'cyan',
    gradientFrom: 'from-slate-800/60',
    gradientVia: 'via-cyan-900/40',
    gradientTo: 'to-slate-800/60',
  },
  {
    id: 2,
    title: 'Tier 2 Subscriber',
    description: 'Subscribe on Twitch',
    benefit: '50% off commissions',
    color: 'teal',
    gradientFrom: 'from-slate-800/60',
    gradientVia: 'via-teal-900/40',
    gradientTo: 'to-slate-800/60',
  },
  {
    id: 3,
    title: 'Tier 3 Subscriber',
    description: 'Subscribe on Twitch',
    benefit: '2 free commissions/month',
    color: 'amber',
    gradientFrom: 'from-slate-800/60',
    gradientVia: 'via-amber-900/40',
    gradientTo: 'to-slate-800/60',
  },
];

export const tosData = {
  title: 'What I Will and Will Not Do for Commissions!',
  items: [
    'I will not share any personal information from anyone sent to me such as logins if I upload the avatar for you.',
    'I will not take complex character commissions.',
    'I have the right to reject the commission.',
    'I will charge you once I will be either uploading the avatar or be sending you the textures once you\'re satisfied on how it looks.',
    'I only accept PayPal for payment! If you can\'t do PayPal, it can be discussed.',
    'You must be available if I have questions during creating the commission.',
    'You must be okay with if I stream the commission on Twitch.',
    'You must be able to send me the file you want textured if I don\'t own it.',
  ],
};

// Queue data is now fetched from backend API
export const queueData = [];
